export const imagesHome = [
    {
        id: 1,
        src: require("../assets/home-page/centre-ville.webp"),
        alt: "Centre ville Gta Rp",
        title: "Centre Ville"
      },
      {
        id: 2,
        src: require("../assets/home-page/centre-ville2.webp"),
        alt: "Centre ville Gta Rp",
        title: "Centre Ville"
      },
      {
        id: 3,
        src: require("../assets/home-page/370z.webp"),
        alt: "Nissan 370z",
        title: "Importations"
      },
      {
        id: 4,
        src: require("../assets/home-page/chiliad.webp"),
        alt: "Mont Chiliad Gta Rp",
        title: "Mapping"
      },
      {
        id: 5,
        src: require("../assets/home-page/chiliad2.webp"),
        alt: "Mont Chiliad Gta Rp",
        title: "Mont Chiliad"
      },
      {
        id: 6,
        src: require("../assets/home-page/chiliad3.webp"),
        alt: "Mont Chiliad Gta Rp",
        title: "Mapping"
      },
      {
        id: 7,
        src: require("../assets/home-page/foraine.webp"),
        alt: "fête foraine Gta Rp",
        title: "Divertissements"
      },
      {
        id: 8,
        src: require("../assets/home-page/foraine2.webp"),
        alt: "fête foraine Gta Rp",
        title: "Divertissements"
      },
      {
        id: 9,
        src: require("../assets/home-page/maze-arena.webp"),
        alt: "Maze Arena Gta Rp",
        title: "Maze Bank Arena"
      },
      {
        id: 9,
        src: require("../assets/home-page/maze-arena2.webp"),
        alt: "Maze Arena Gta Rp",
        title: "Evenements"
      },
      {
        id: 10,
        src: require("../assets/home-page/noel.webp"),
        alt: "Sapin de noël Gta Rp",
        title: "Saisons"
      }
];